import React from 'react';
import styled from 'styled-components';
import Arrow from '~/assets/select/arrow.svg';

const SelectWrapper = styled.div`
  position: relative;
  role: presentation;
`;

const StyledSelect = styled.select`
  appearance: none;
  width: 100%;
  padding-right: 40px;
  font-size: 12px;
  line-height: 1.5;
  font-family: Raleway;
  color: #2e2e2e;
  padding: 12px 15px;
  border: none;
  border-radius: 5px;
  background: #f5f5f5;
  box-sizing: border-box;

  &::placeholder {
    color: #6f6f6f;
  }
`;

const StyledArrow = styled(Arrow)`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 22px;
  height: 22px;
`;

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options?: SelectOption[];
  placeholder?: string;
  children?: React.ReactNode;
}

export const Select: React.FC<SelectProps> = ({
  options,
  placeholder,
  ...props
}) => {
  return (
    <SelectWrapper>
      <StyledSelect {...props}>
        {placeholder && <option value="">{placeholder}</option>}
        {options?.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
      <StyledArrow aria-hidden="true" />
    </SelectWrapper>
  );
};
